import { HttpContextToken } from '@angular/common/http';

export const SKIP_RESOURCE_ERROR_REDIRECT = new HttpContextToken<boolean>(() => false);
export const SKIP_NOT_FOUND_REDIRECT = new HttpContextToken<boolean>(() => false);
